export default Object.freeze({
  RequestPendingApproval: 1,
  RequestPendingCompleteInformation: 2,
  RequestPendingTaskCompletion: 3,
  RequestApproved: 4,
  RequestRejected: 5,
  RequestCanceled: 6,
  AccountConfirmation: 7,
  AccountWelcomeMessage: 8,
  AccountResetPassword: 9,
  RequestAttachments: 10,
  ExecutionSteps: 11,
  RequestPendingSignature: 12,
  ActionSendEmail: 13,
  RequestScheduledExecution: 14,
  AccountTwoFactorValidationCode: 15,
});
